interface CarouselItem {
  tag: string;
  title: string;
  desc: string;
  image: string;
  imageAlt: string;
  stat: string;
  statLabel: string;
}

const items: CarouselItem[] = [
  {
    tag: '热播大片',
    title: '《暗夜追踪》全网首播',
    desc: '年度悬疑巨制重磅上线，实力派演员倾情演绎，层层反转烧脑不断，带你走进迷雾重重的真相世界。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20thriller%20film%20scene%20with%20a%20detective%20walking%20through%20foggy%20alley%20at%20night%2C%20warm%20amber%20street%20lamp%20lighting%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic%2C%20high%20contrast%20shadows%2C%20professional%20movie%20photography%2C%20moody%20atmosphere&width=800&height=450&seq=carousel-01&orientation=landscape',
    imageAlt: '暗夜追踪 - 悬疑大片首播',
    stat: '9.2',
    statLabel: '评分',
  },
  {
    tag: '独家剧集',
    title: '《长安风云录》第三季',
    desc: '古装权谋大剧回归，精良制作呈现盛世风华，朝堂博弈与江湖恩怨交织，口碑持续攀升中。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20chinese%20palace%20drama%20scene%20with%20imperial%20court%20setting%2C%20warm%20golden%20lantern%20lighting%2C%20traditional%20architecture%20and%20costumes%2C%20cinematic%20widescreen%20composition%2C%20epic%20historical%20film%20aesthetic%2C%20rich%20warm%20tones%2C%20professional%20production%20quality&width=800&height=450&seq=carousel-02&orientation=landscape',
    imageAlt: '长安风云录 - 古装权谋大剧',
    stat: '8.8',
    statLabel: '评分',
  },
  {
    tag: '院线同步',
    title: '《星际迷航：新纪元》',
    desc: '科幻冒险史诗级新篇章，震撼视觉特效带来沉浸式宇宙旅程，硬核科幻迷不容错过的视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%20with%20a%20spaceship%20flying%20through%20colorful%20nebula%2C%20warm%20orange%20and%20gold%20star%20light%2C%20cinematic%20widescreen%20composition%2C%20professional%20visual%20effects%20quality%2C%20dramatic%20lighting%2C%20immersive%20atmosphere&width=800&height=450&seq=carousel-03&orientation=landscape',
    imageAlt: '星际迷航：新纪元 - 科幻大片',
    stat: '9.5',
    statLabel: '热度',
  },
  {
    tag: '口碑佳作',
    title: '《小镇故事》温情治愈',
    desc: '豆瓣高分文艺片温暖上线，细腻描绘小城人情冷暖，平凡生活中的感动瞬间，治愈每一颗漂泊的心。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20heartfelt%20film%20scene%20of%20a%20small%20town%20street%20with%20golden%20sunset%20lighting%2C%20gentle%20color%20palette%2C%20charming%20old%20buildings%2C%20cinematic%20composition%2C%20nostalgic%20atmosphere%2C%20soft%20focus%20background%2C%20professional%20film%20photography&width=800&height=450&seq=carousel-04&orientation=landscape',
    imageAlt: '小镇故事 - 温情治愈佳片',
    stat: '9.0',
    statLabel: '评分',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8 md:mb-10">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精选专题</h2>
              <p className="text-sm text-foreground-600 mt-1">编辑精选 · 每日更新推荐</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {items.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                className="group relative flex flex-col sm:flex-row bg-background-200 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-300"
              >
                <div className="relative sm:w-[220px] md:w-[260px] shrink-0 aspect-[16/9] sm:aspect-auto sm:h-[180px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-200 sm:hidden"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                  <div>
                    <span className="hidden sm:inline-block px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-2 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950 mt-1 sm:mt-0 group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">
                      {item.desc}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-300">
                    <span className="text-lg font-bold text-primary-500">{item.stat}</span>
                    <span className="text-xs text-foreground-600">{item.statLabel}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}